import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { routes } from '@/lib/config'
import { AuthLayout } from '@/components/auth'

export default function Home() {
  const navigate = useNavigate()
  const { user, loading: authLoading } = useAuth()

  useEffect(() => {
    if (authLoading) return
    if (user) navigate(routes.dashboard)
    else navigate(routes.login)
  }, [user, authLoading, navigate])

  return <AuthLayout subtitle="Carregando..." isLoading />
}
